import { render, staticRenderFns } from "./ContentDetailRate.vue?vue&type=template&id=0a8a49f3"
import script from "./ContentDetailRate.js?vue&type=script&lang=js&external"
export * from "./ContentDetailRate.js?vue&type=script&lang=js&external"
import style0 from "./ContentDetailRate.vue?vue&type=style&index=0&id=0a8a49f3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports